<template>
  <div v-if="tradeApplyOrderVO.applyType === '02'">
    <div class="trade-order-block">
      <div class="block-title">批量化物料</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">业务线</el-col>
          <el-col :span="9">{{ setClientType(tradeApplyInfoVO.clientType) }}</el-col>
          <el-col :span="3">渠道</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.channelName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">所属事业部</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.buName }}</el-col>
          <el-col :span="3">所属区域</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.regionName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">活动主题</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.eventSubject }}</el-col>
          <el-col :span="3">预计投入门店数量</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.estimatePocQty }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">物料</el-col>
          <el-col :span="10">
            <el-row>
              <el-col :span="9"><span class="bulk-list-title">物料名称</span></el-col>
              <el-col :span="6"><span class="bulk-list-title">数量</span></el-col>
              <el-col :span="9"><span class="bulk-list-title">品牌</span></el-col>
            </el-row>
            <el-row v-for="(item, index) in tradeBmApplyDetailList" :key="index" class="bulk-list">
              <el-col :span="9"><span class="bulk-list-content">{{ item.itemName }}</span></el-col>
              <el-col :span="6"><span class="bulk-list-content">{{ item.itemQty }}</span></el-col>
              <el-col :span="9"><span class="bulk-list-content">{{ item.subBrandName }}</span></el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">供应商</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorName }}</el-col>
          <el-col :span="3">交货日期</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.deliveryDate | parseTime('{y}-{m}-{d}') }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">申报说明</el-col>
          <el-col :span="21" style="word-break: break-all">{{ tradeApplyInfoVO.applyDesc }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeBmApplyImageList.length">
          <el-col :span="3">示例图片</el-col>
          <el-col :span="21">
            <div class="bulk-img" v-viewer="{movable: true}">
              <div v-for="img in tradeBmApplyImageList" :key="img.imageId">
                <img :src="getImg(img.imageUri)">
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'

export default {
  name: 'store-bulk-info',
  data () {
    return {
      tradeApplyOrderVO: '',
      tradeApplyInfoVO: '',
      tradeBmApplyDetailList: [],
      tradeBmApplyImageList: []
    }
  },
  created () {

  },
  methods: {
    setBulkInfo (val) {
      this.tradeApplyOrderVO = val
      this.tradeApplyInfoVO = val.tradeApplyInfoVO
      this.tradeBmApplyDetailList = val.tradeBmApplyDetailList
      this.tradeBmApplyImageList = val.tradeBmApplyImageList || []
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    },

    setClientType (val) {
      if (val === '01') return 'TMKT'
      if (val === '02') return 'ISP'
      if (val === '03') return 'KA'
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.bulk-list-title {
  color: #333;
}

.bulk-list {
  margin-top: 8px;
}

.bulk-list-content {
  color: #333;
  font-size: 13px
}

.bulk-img {
  display: flex;

  div {
    width: 150px;
    height: 110px;
    margin-right: $content-middle;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      border-radius: 8px;
    }
  }
}
</style>
